import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    smart_toy: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM9 8c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm4 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm2-5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
      </svg>
    ),
    support_agent: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"/>
        <circle cx="9" cy="13" r="1"/>
        <circle cx="15" cy="13" r="1"/>
        <path d="M18 11.03C17.52 8.18 15.04 6 12.05 6c-3.03 0-6.29 2.51-6.03 6.45 2.47-1.01 4.33-3.21 4.86-5.89 1.31 2.63 4 4.44 7.12 4.47z"/>
      </svg>
    ),
    attach_money: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
      </svg>
    ),
    access_time: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    ),
    business: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const AIVsCallCenter = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'business owner'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'business owner' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const comparisonData = [
    {
      category: "Setup Time",
      ai: "24 hours to launch",
      callCenter: "3-6 months minimum",
      aiIcon: "access_time",
      callCenterIcon: "schedule"
    },
    {
      category: "Monthly Cost",
      ai: "$399 unlimited calls",
      callCenter: "$3,000-$10,000+ minimum",
      aiIcon: "attach_money",
      callCenterIcon: "trending_up"
    },
    {
      category: "Consistency",
      ai: "Perfect service every call",
      callCenter: "Quality varies by agent and shift",
      aiIcon: "checkCircle",
      callCenterIcon: "warning"
    },
    {
      category: "Integration",
      ai: "Purpose-built for your business",
      callCenter: "Generic scripts, limited customization",
      aiIcon: "smart_toy",
      callCenterIcon: "support_agent"
    },
    {
      category: "Scalability",
      ai: "Instant scaling to any volume",
      callCenter: "Slow scaling, requires hiring",
      aiIcon: "trending_up",
      callCenterIcon: "business"
    },
    {
      category: "Data Security",
      ai: "Your data stays secure and private",
      callCenter: "Third-party access to sensitive data",
      aiIcon: "checkCircle",
      callCenterIcon: "warning"
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "AI Receptionist vs Call Center: Complete Cost and Performance Comparison",
    "description": "Compare AI receptionists vs traditional call centers. See why AI provides better service at 95% lower cost with instant setup and perfect consistency.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist vs Call Center: 95% Cost Savings with Better Service"
        description="Compare AI receptionists vs call centers. AI provides 24/7 perfect service for $399/month vs $3,000-$10,000 for call centers. Ready in 24 hours, not months."
        keywords="ai receptionist vs call center, call center alternative, ai vs outsourced call center, virtual receptionist vs call center, automated phone system vs call center"
        canonical="https://receptioneer.ai/ai-vs-call-center"
        ogTitle="AI Receptionist vs Call Center - 95% Cost Savings with Perfect Service"
        ogDescription="Why smart businesses are switching from expensive call centers to AI receptionists. Better service, lower cost, instant setup."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              AI Receptionist vs
              <br />
              <span className="text-blue-200">Call Center</span>
            </h1>
            
            <p className="text-xl text-blue-100 mb-12 leading-relaxed max-w-3xl mx-auto">
              Smart businesses are ditching expensive call centers for AI receptionists. Get better service at 95% lower cost with instant setup instead of months of delays.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Replace Your Call Center →
              </button>
              
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Compare Live
              </a>
            </div>
          </div>
        </section>

        {/* Shocking Stats */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              The <span className="text-blue-900">Shocking Truth</span> About Call Centers
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8 text-center">
              <div className="bg-white rounded-3xl p-8 shadow-sm">
                <div className="text-4xl font-black text-red-600 mb-2">95%</div>
                <div className="text-gray-700 font-bold mb-2">More Expensive</div>
                <div className="text-sm text-gray-600">Call centers cost $3,000-$10,000/month vs $399 for AI</div>
              </div>
              <div className="bg-white rounded-3xl p-8 shadow-sm">
                <div className="text-4xl font-black text-red-600 mb-2">6 months</div>
                <div className="text-gray-700 font-bold mb-2">Setup Time</div>
                <div className="text-sm text-gray-600">Call centers take months to set up vs 24 hours for AI</div>
              </div>
              <div className="bg-white rounded-3xl p-8 shadow-sm">
                <div className="text-4xl font-black text-red-600 mb-2">40%</div>
                <div className="text-gray-700 font-bold mb-2">Quality Issues</div>
                <div className="text-sm text-gray-600">Call center quality varies vs 100% consistent AI</div>
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Comparison */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Side-by-Side <span className="text-blue-900">Comparison</span>
            </h2>
            
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-3xl shadow-lg overflow-hidden">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left font-black text-gray-900">Feature</th>
                    <th className="px-6 py-4 text-center font-black text-blue-900">
                      <div className="flex items-center justify-center gap-2">
                        <MaterialIcon name="smart_toy" className="w-6 h-6" />
                        AI Receptionist
                      </div>
                    </th>
                    <th className="px-6 py-4 text-center font-black text-gray-700">
                      <div className="flex items-center justify-center gap-2">
                        <MaterialIcon name="support_agent" className="w-6 h-6" />
                        Call Center
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {comparisonData.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-6 font-bold text-gray-900">{item.category}</td>
                      <td className="px-6 py-6 text-center">
                        <div className="flex items-center justify-center gap-3 text-blue-900">
                          <MaterialIcon name={item.aiIcon} className="w-5 h-5" />
                          <span className="font-semibold">{item.ai}</span>
                        </div>
                      </td>
                      <td className="px-6 py-6 text-center">
                        <div className="flex items-center justify-center gap-3 text-gray-700">
                          <MaterialIcon name={item.callCenterIcon} className="w-5 h-5" />
                          <span>{item.callCenter}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Real Cost Analysis */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Real Cost <span className="text-blue-900">Analysis</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="bg-blue-900 text-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="smart_toy" className="w-8 h-8" />
                  <h3 className="text-2xl font-black">AI Receptionist</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="flex justify-between">
                    <span>Monthly Service</span>
                    <span className="font-bold">$399</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Setup Fee</span>
                    <span className="font-bold">$0</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Training Cost</span>
                    <span className="font-bold">$0</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Management Overhead</span>
                    <span className="font-bold">$0</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Scaling Costs</span>
                    <span className="font-bold">$0</span>
                  </div>
                  <div className="border-t border-blue-700 pt-4">
                    <div className="flex justify-between text-xl font-black">
                      <span>Annual Total</span>
                      <span>$4,788</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="support_agent" className="w-8 h-8 text-gray-700" />
                  <h3 className="text-2xl font-black text-gray-900">Call Center</h3>
                </div>
                
                <div className="space-y-4 text-gray-700">
                  <div className="flex justify-between">
                    <span>Monthly Service (minimum)</span>
                    <span className="font-bold">$5,000</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Setup & Integration</span>
                    <span className="font-bold">$10,000</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Training & Scripts</span>
                    <span className="font-bold">$5,000</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Management & QA</span>
                    <span className="font-bold">$2,000/mo</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Technology Platform</span>
                    <span className="font-bold">$1,000/mo</span>
                  </div>
                  <div className="border-t border-gray-200 pt-4">
                    <div className="flex justify-between text-xl font-black text-gray-900">
                      <span>Annual Total</span>
                      <span>$111,000+</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-8">
              <div className="bg-green-100 text-green-800 inline-block px-6 py-3 rounded-xl font-black text-xl">
                Save $106,212+ per year with AI
              </div>
            </div>
          </div>
        </section>

        {/* Hidden Problems with Call Centers */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Hidden Problems with <span className="text-red-600">Call Centers</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Agent Turnover</h3>
                    <p className="text-gray-700">Call centers have 70%+ annual turnover. Constant retraining, inconsistent service, lost knowledge.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Data Security Risks</h3>
                    <p className="text-gray-700">Third-party access to your customer data. Compliance challenges and potential breaches.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Quality Inconsistency</h3>
                    <p className="text-gray-700">Service quality varies by agent mood, time of day, training level, and experience.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Hidden Costs</h3>
                    <p className="text-gray-700">Setup fees, training costs, technology platforms, management overhead, and scaling expenses.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Slow Setup</h3>
                    <p className="text-gray-700">3-6 months minimum to get started. Contracts, negotiations, training, integration delays.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Scaling Difficulties</h3>
                    <p className="text-gray-700">Need more capacity? Wait weeks for hiring and training. Scaling down? You're locked in contracts.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Make the Switch */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Ready to Ditch Your Call Center?
            </h2>
            
            <p className="text-xl text-blue-100 mb-12">
              Join the smart businesses saving 95% on phone costs while delivering perfect customer service.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-blue-100 mb-6">per month • unlimited calls • perfect service</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Replace Your Call Center →
              </button>
            </div>
            
            <p className="text-blue-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Replace Your Call Center"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your AI receptionist ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. David Williams"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="david@business.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Replace My Call Center'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/ai-vs-call-center" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AIVsCallCenter;